import { AssociatedCustomer, Status, Role } from 'src/shared/types';

export const getUserStatusFromEnum = (status: string) => {
    switch (status) {
        case 'Active':
            return Status.SUCCESS;
        case 'Invited':
            return Status.WARNING;
        default:
            return Status.ERROR;
    }
};

export const checkIfCustomerAdmin = (customerList: AssociatedCustomer[], currentCustomerId: string) => {
    let isAdmin = false;
    customerList.some((customer: AssociatedCustomer) => {
        if (customer.roles?.includes(Role.CUSTOMER_ADMIN) && customer.customerId === currentCustomerId) isAdmin = true;
    });
    return isAdmin;
};

export const getProjectsForEditUser = (userCustomers: AssociatedCustomer[]) => {
    return userCustomers
        .map(customer => customer?.projects || [])
        .flat()
        .map(project => {
            return {
                projectId: project.projectId,
                roles: project.roles,
            };
        });
};

export const getCustomersForEditUser = (userCustomers: AssociatedCustomer[]) => {
    return userCustomers.map(customer => {
        return {
            customerId: customer.customerId,
            active: customer.active,
            roles: customer.roles,
            updatedAt: customer.updatedAt,
        };
    });
};
